import { GetStaticProps } from 'next'
import React from 'react'

import Page from '@aletheia/common/components/Page'
import { preCacheApolloQueries } from '@aletheia/common/lib/apollo'
import {
  GetOrganizationsDocument,
  GetPaymentStatsAggregateDocument,
} from '@aletheia/graphql'

import {
  HeroUnit,
  OurFunds,
  GetFundedList,
  FundManagers,
  PartnerList,
} from '../components/Home'
import { fetchFunds, IFund, IPerson, fetchSeriesEntries } from '../contentful'

type HomeProps = {
  Funds: IFund[]
  FundManagerTeam: IPerson[]
}

const Home: React.FC<HomeProps> = ({ Funds, FundManagerTeam }) => {
  const baseUrl =
    (process.env.VERCEL_URL && `https://${process.env.VERCEL_URL}`) ||
    process.env.NEXT_PUBLIC_BASE_URL

  return (
    <Page
      title="Effective Altruism Funds"
      variant="full"
      showTitle={false}
      showPageTitle={false}
      ogImage={`${baseUrl}/landing/og-image.jpg`}
      description={'We fund outstanding projects focused on social impact'}
    >
      <HeroUnit />
      <GetFundedList />
      <OurFunds Funds={Funds} />
      <FundManagers FundManagers={FundManagerTeam} />
      <PartnerList />
    </Page>
  )
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
  const initialApolloState = await preCacheApolloQueries([
    GetOrganizationsDocument,
    GetPaymentStatsAggregateDocument,
  ])

  const [Funds, FundManagerTeam] = await Promise.all([
    fetchFunds(),
    fetchSeriesEntries('homepage-fund-managers'),
  ])

  if (!FundManagerTeam) throw new Error('Missing Homepage Fund Managers')

  return {
    props: {
      Funds,
      FundManagerTeam,
      initialApolloState,
    },
    revalidate: 20,
  }
}

export default Home
